import {ActionTree} from 'vuex';
import axios from 'axios';
import {RootState} from '@/store/types';
import {StatisticState, ViberDetailFilterParams, ViberDetailItem, ViberDetailItemInfo, ViberGroupFilterParams, ViberGroupItem} from './types';

export const actions: ActionTree<StatisticState, RootState> = {

  async getViberStatisticDetail({commit}, filter: ViberDetailFilterParams) {
    commit('setLoading', true);
    try {
      const resp = await axios({url: '/stats-api/detail/viber', params: filter});
      let messages = resp.data?.messages ?? [];
      if (filter.page_number > 1) {
        commit('pushViberStatisticDetail', messages);
      } else {
        commit('setViberStatisticDetail', messages);
      }
      return resp;
    } catch (error) {
      throw error;
    } finally {
      commit('setLoading', false);
    }
  },

  async getViberStatisticDetailInfo({commit}, id: string) {
    commit('setLoading', true);
    try {
      const response = await axios({url: `/stats-api/detail/viber/${encodeURIComponent(id)}`});
      return response;
    } catch (error) {
      throw error;
    } finally {
      commit('setLoading', false);
    }
  },

  async exportViberStatisticDetail({commit}, filter: ViberDetailFilterParams) {
    commit('setLoading', true);
    try {
      const response = await axios({url: '/stats-api/detail/viber/export', params: filter});
      return response;
    } catch (error) {
      throw error;
    } finally {
      commit('setLoading', false);
    }
  },

  async resendViberMessage({commit}, id: string) {
    commit('setLoading', true);
    try {
      const response = await axios({
        method: 'post',
        url: '/acapi/tools/viber/resend',
        data: {message_ids: [id]}
      })
      return response;
    } catch (error) {
      throw error;
    } finally {
      commit('setLoading', false);
    }
  },

  async getViberStatisticGroup({commit}, filter: ViberGroupFilterParams) {
    commit('setLoading', true);
    try {
      const response = await axios({url: '/stats-api/group/viber', params: filter});
      commit('setViberStatisticGroup', response.data.messages);
      commit('setViberMessagesCount', response.data.messages_count);
      return response;
    } catch (error) {
      throw error;
    } finally {
      commit('setLoading', false);
    }
  },

  async exportViberStatisticGroup({commit}, filter: ViberGroupFilterParams) {
    commit('setLoading', true);
    try {
      const response = await axios({url: '/stats-api/group/viber/export', params: filter});
      return response;
    } catch (error) {
      throw error;
    } finally {
      commit('setLoading', false);
    }
  },

};
